import React from 'react';
import TabPanel from '../../components/TabPanel';
import Grid from '@mui/material/Grid';
import { JobRule, Rule } from '../../types/rule';
import JobRuleSelect from './JobRuleSelect';
import JobRules from './JobRules';
import useConfigStyles from '../../components/useConfigStyles';

interface JobRulesTabPanelProps {
  rules: Rule[];
  index: number;
  selectedTab: number;
  editable: boolean;
  onRulesUpdate?: (rules: Rule[]) => void;
}

function JobRulesTabPanel({ rules, index, selectedTab, editable, onRulesUpdate }: JobRulesTabPanelProps): JSX.Element {
  const classes = useConfigStyles();

  const addRule = (rule: JobRule) => {
    if (!onRulesUpdate) {
      return;
    }
    const updatedRules = rules;
    const ruleIndex = rules.findIndex((v) => v.Name === rule.Name);
    if (ruleIndex >= 0) {
      updatedRules[ruleIndex].Severity = rule.Severity;
      updatedRules[ruleIndex].Disabled = rule.Disabled;
      onRulesUpdate(updatedRules);
    } else {
      onRulesUpdate(updatedRules.concat({ ...rule, Statement: '' }));
    }
  };

  const removeRule = (rule: Rule) => {
    if (!onRulesUpdate) {
      return;
    }
    const ruleIndex = rules.indexOf(rule);
    rules.splice(ruleIndex, 1);
    onRulesUpdate(rules);
  };

  return (
    <TabPanel selectedValue={selectedTab} index={index} className={classes.container}>
      {editable && (
        <Grid item className={classes.input} md={6}>
          <JobRuleSelect rules={rules} addRule={addRule} />
        </Grid>
      )}
      <Grid item className={classes.input} md={6}>
        <JobRules rules={rules} removeRule={removeRule} editable={editable} />
      </Grid>
    </TabPanel>
  );
}

JobRulesTabPanel.defaultProps = {
  onRulesUpdate: () => {},
};

export default JobRulesTabPanel;
